import React from 'react';
import { UserActivityDetailSkeleton } from '@components/Feed/User/Skeleton';
import { PreviewSkeleton as PreviewSkeletonV2 } from '@components/Playlists/Preview/Skeleton';
import { ComponentContainer } from '../shared';

export const PlaylistCreatedSkeleton = () => (
  <ComponentContainer css={{ paddingX: 0 }}>
    <UserActivityDetailSkeleton />
    <div className="lg:ml-[65px]">
      <PreviewSkeletonV2 />
    </div>
  </ComponentContainer>
);
